module.exports = __webpack_public_path__ + "static/img/i.c1fcf9b.jpg";